import { userPreferencesApiConnector } from 'apiConnector/userPreferences/userPreferences';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, mergeMap, timeout, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  userPreferencesSaveFailed,
  userPreferencesSaveSucceed,
  userPreferencesSaveTimeouted,
} from 'state/userPreferences/userPreferences.action';
import type { UserPreferences } from 'state/userPreferences/userPreferences.model';

export interface SaveUserPreferencesEpicApi {
  saveUserPreferences(userPreferences: UserPreferences): Observable<any>;
}

export function saveUserPreferences(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { selectors: { areUserPreferencesReady, getUserPreferencesAll }, httpClient }) =>
    action$.pipe(
      ofType(
        'USER_PREFERENCES_DARK_MODE_CHANGED',
        'USER_PREFERENCES_LANDING_PAGE_CHANGED',
        'USER_PREFERENCES_QUOTE_WORKSPACE_VERSION_CHANGED',
        'USER_PREFERENCES_BATCH_WORKSPACE_VERSION_CHANGED',
        'USER_PREFERENCES_DEFAULT_FIELD_VALUES_CHANGED',
        'USER_PREFERENCES_LANGUAGE_CHANGED',
        'USER_PREFERENCES_DISPLAY_PRECISION_CHANGED',
        'USER_PREFERENCES_UNDERLYING_CODE_TYPE_CHANGED',
        'USER_PREFERENCES_SPMTABS_UPDATED',
        'USER_PREFERENCES_DISCOVER_PAGE_REGION_CHANGED',
        'USER_PREFERENCES_SECONDARY_MARKET_PRODUCT_SEARCH_CODE_TYPE_CHANGED',
        'USER_PREFERENCES_SECONDARY_MARKET_IS_CLOSE_TAB_CLOSE_TAB_WHEN_LIVE_TRADE_CP_ORDER_IS_PLACED_CHANGED',
        'USER_PREFERENCES_PINNED_PRODUCTS_VARIATIONS_CHANGED',
        'USER_PREFERENCES_ESSENTIAL_PINNED_PRODUCTS_VARIATIONS_CHANGED',
        'USER_PREFERENCES_NOTIFICATION_CONTACTS_CHANGED',
        'USER_PREFERENCES_NEVER_SHOW_BATCH_WORKSPACE_SHORTCUT_CHEATSHEET_BANNER_CHANGED',
        'USER_PREFERENCES_ESSENTIAL_EXPANDED_BLOCKS_TOGGLE',
      ),
      withLatestFrom(state$),
      filter(([_, state]) => areUserPreferencesReady(state)),
      mergeMap(([_, state]) => {
        const userPreferences: UserPreferences = getUserPreferencesAll(state);
        return userPreferencesApiConnector(httpClient)
          .saveUserPreferences(userPreferences)
          .pipe(
            mergeMap(() => of(userPreferencesSaveSucceed(userPreferences))),
            catchError(() => of(userPreferencesSaveFailed())),
            timeout({ each: timeoutInMillis, with: () => of(userPreferencesSaveTimeouted()), scheduler: appScheduler }),
          );
      }),
    );
}
